import { convertToReferenceNumber } from 'src/helpers/globals'

function defaultReferencePayload (form) {
  return {
    title: form.title,
    standard: form.standard,
    update_available: false,
    contains_draft: false,
    revisions: []
  }
}

export function defaultGroup (title, forms = {}) {
  return {
    title,
    forms
  }
}

export function checkAndUpdateFormGroup (form, group) {
  const refKey = form.reference_id

  if (!group[refKey]) {
    group[refKey] = defaultReferencePayload(form)
  }

  if (form.status === 'UPDATE_PENDING') {
    group[refKey].update_available = true
  }

  if (form.status === 'DRAFT') {
    group[refKey].contains_draft = true
  }

  group[refKey].revisions.push(form)
}

// Return all forms which match a specific set of reference IDs
// onlyMatches=true will ignore forms which don't meet the matchRef array of reference IDs
// orderByRefs=true will return revisions in the order in which matchRef is stored
export function matchFormsByReference (forms, matchRef = [], orderByRefs = false) {
  if (matchRef.length < 1) {
    return {}
  }

  const groups = {}

  for (const form of forms) {
    const refKey = form.reference_id

    if (!matchRef.includes(refKey)) {
      continue
    }

    checkAndUpdateFormGroup(form, groups)
  }

  if (!orderByRefs) {
    return groups
  }

  // Sort the object in the order specified by matchRef
  return Object.fromEntries(Object.entries(groups).sort((a, b) => {
    return matchRef.indexOf(a[0]) - matchRef.indexOf(b[0])
  }))
}

// Return all forms grouped by their category and each reference ID
export function groupFormsByCategory (forms) {
  const categories = {}

  for (const form of forms) {
    const category = form.category || 'Uncategorised'
    // Underscore at start to stop key order changing when binding a customGroup to the main category list
    const categoryRef = `_${convertToReferenceNumber(category)}`

    if (!categories[categoryRef]) {
      categories[categoryRef] = defaultGroup(category)
    }

    checkAndUpdateFormGroup(form, categories[categoryRef].forms)
  }

  // Sort the object by category name
  return Object.keys(categories).sort().reduce(
    (obj, key) => {
      obj[key] = categories[key]
      return obj
    },
    {}
  )
}
